import { Card, CardContent } from "@/components/ui/card";
import { Trophy } from "lucide-react";

export function PlayerTotals({ round, playerTotals }) {
  return (
    <Card className="card-active mb-4">
      <CardContent className="p-3">
        <h3 className="text-sm font-bold text-[#0F172A] mb-3 flex items-center gap-2">
          <Trophy className="w-4 h-4 text-[#D4A373]" />
          Totales por Jugador
        </h3>
        <div className="overflow-x-auto">
          <table className="w-full text-xs">
            <thead>
              <tr className="border-b border-gray-200">
                <th className="text-left py-1.5 px-1 font-semibold text-[#64748B]">Jugador</th>
                <th className="text-center py-1.5 px-1 font-semibold text-[#1B4D3E]">FS</th>
                <th className="text-center py-1.5 px-1 font-semibold text-blue-600">Ind</th>
                <th className="text-center py-1.5 px-1 font-bold text-[#0F172A] bg-gray-50">TOT</th>
              </tr>
            </thead>
            <tbody>
              {round?.players?.sort((a, b) => (playerTotals[b.player_id]?.total || 0) - (playerTotals[a.player_id]?.total || 0)).map((player) => {
                const totals = playerTotals[player.player_id] || {};
                return (
                  <tr key={player.player_id} className="border-b border-gray-100">
                    <td className="py-1.5 px-1">
                      <div className="flex items-center gap-1.5">
                        <span className={`w-1.5 h-1.5 rounded-full ${player.is_base ? 'bg-[#1B4D3E]' : 'bg-[#D4A373]'}`}></span>
                        <span className="font-medium text-[#0F172A]">{player.name?.split(' ')[0]}</span>
                      </div>
                    </td>
                    <td className={`text-center py-1.5 px-1 font-semibold ${totals.foursome > 0 ? 'text-green-600' : totals.foursome < 0 ? 'text-red-600' : 'text-gray-500'}`}>
                      {totals.foursome > 0 ? '+' : ''}{totals.foursome || 0}
                    </td>
                    <td className={`text-center py-1.5 px-1 font-semibold ${totals.individuals > 0 ? 'text-green-600' : totals.individuals < 0 ? 'text-red-600' : 'text-gray-500'}`}>
                      {totals.individuals > 0 ? '+' : ''}{totals.individuals || 0}
                    </td>
                    <td className={`text-center py-1.5 px-1 font-bold bg-gray-50 ${totals.total > 0 ? 'text-green-600' : totals.total < 0 ? 'text-red-600' : 'text-gray-500'}`}>
                      {totals.total > 0 ? '+' : ''}{totals.total || 0}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
